module.exports = {
      id: "automobile-usage",
      viewBox: "0 0 31.664 23.083",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#automobile",
      toString: function () {
        return this.url;
      }
    }